import { all, call, put } from 'redux-saga/effects';
import { userInfo as userInfoService, appConfig } from '../services';
import { redeemTokenV2 } from '../containers/supplements-order/services/supplementsOrder';
import { updateLoginState, setAppConfig } from '../actions';
import { showError } from '../utils';

/**
 * Exchange the upsell deeplink's one-time token (OTT) for a JWT and log the
 * user in with it, so every upsell page (and the shared components they use)
 * can read the token from `state.user.authToken`.
 */
export function* redeemUpsellToken({ payload }) {
  const { ott, onSuccess, onFailure } = payload;
  try {
    const { authToken, flow, data } = yield call(redeemTokenV2, ott);
    if (!authToken) {
      const err = new Error('redeem-token-v2 returned no authorization header');
      err.data = {
        errorHeader: 'Authentication failed',
        errorMessage: 'We could not verify this link.',
      };
      throw err;
    }

    yield put({
      type: 'AUTH_TOKEN',
      payload: authToken,
    });

    const [userInfoResult, appConfigResult] = yield all([
      call(userInfoService, authToken),
      call(appConfig, authToken),
    ]);

    yield all([
      put({
        type: 'SET_USER_INFO',
        payload: userInfoResult,
      }),
      put(setAppConfig(appConfigResult.config)),
    ]);
    yield put(updateLoginState('LOGGED_IN'));

    if (onSuccess) {
      onSuccess(authToken, flow, data);
    }
  } catch (err) {
    console.error('Failed to redeem upsell token:', err);
    showError(err);
    if (onFailure) {
      onFailure(err);
    }
  }
}
